import Rotate from "react-reveal/Rotate";
import React, { useContext, useEffect } from "react";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import { Doughnut, Pie } from "react-chartjs-2";
import useHome from "../../controllers/useHome";
import Account from "../../context/acount";
import { account_type, permission_type } from "../../constants";
ChartJS.register(ArcElement, Tooltip, Legend);

export default function Home() {
  const { control } = useContext(Account);
  const { user, employee } = useHome(
    control ? control[permission_type.VIEW_USER_LIST] : undefined,
    control ? control[permission_type.VIEW_EMPLOYEE_LIST] : undefined
  );
  const userdata = {
    labels: ["user verified", "user Not verified"],
    datasets: [
      {
        label: "Total Number",
        data: user ? [user.verified, user.not_verified] : [0, 0],
        backgroundColor: ["green", "red"],
        borderColor: ["rgba(255, 99, 132, 1)", "rgba(54, 162, 235, 1)"],
        borderWidth: 1,
      },
    ],
  };

  const employeedata = {
    labels: ["employee verified", "employee Not verified"],
    datasets: [
      {
        label: "Total Number",
        data: employee ? [employee.verified, employee.not_verified] : [0, 0],
        backgroundColor: ["green", "red"],
        borderColor: ["rgba(255, 99, 132, 1)", "rgba(54, 162, 235, 1)"],
        borderWidth: 1,
      },
    ],
  };
  if (!control) return "Loading..";
  return (
    <div>
      <div className="flex flex-wrap m-auto  pl-[20%] mt-2">
        {!control[permission_type.VIEW_EMPLOYEE_LIST] &&
          !control[permission_type.VIEW_USER_LIST] && (
            <p className="font-Roboto text-xl font-bold text-center m-auto">Nothing to show</p>
          )}
        {user && (
          <div>
            <Rotate top left>
              <Doughnut data={userdata} />
            </Rotate>
          </div>
        )}
        {employee && (
          <div>
            <Rotate top left>
              <Doughnut data={employeedata} />
            </Rotate>
          </div>
        )}
      </div>
      <div className="flex flex-wrap m-auto  pl-[20%] mt-2">
        {user && (
          <div>
            <Rotate top left>
              <Pie data={userdata} />
            </Rotate>
          </div>
        )}
        {employee && (
          <div>
            <Rotate top left>
              <Pie data={employeedata} />
            </Rotate>
          </div>
        )}
      </div>
    </div>
  );
}
